import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {onMounted, onUnmounted, reactive} from "vue";
import SlideView from "@/components/SlideView.vue";
import {IconFont} from "@/lib/util";
import {editor} from "@/app/editor/index";
import {MenuInfo} from "ant-design-vue/es/menu/src/interface";
import emit from "@/lib/emit";
import {IModule} from "src/app/editor/modules";
import {cardTags} from "../templates";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditorSide',
  setup(__props) {

const info = reactive({menu: {toggle: false, modules: null as IModule[] | null, selected: [] as number[]}})

onMounted(() => {
  emit.on('editor.section.active.scroll', (e) => {
    if (editor.activity && typeof e == 'number' && info.menu.selected[0] != e) {
      info.menu.modules = editor.activity.modules
      info.menu.selected = [e]
    }
  })
})

onUnmounted(() => emit.off('editor.section.active.scroll'))
const onSelect = (m: MenuInfo) => {
  if (editor.activity) emit.emit('editor.section.active.click', m.key)
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createBlock(SlideView, {
    toggle: info.menu.toggle,
    "onUpdate:toggle": _cache[1] || (_cache[1] = ($event: any) => ((info.menu.toggle) = $event))
  }, {
    default: _withCtx(() => [
      (info.menu.modules)
        ? (_openBlock(), _createBlock(_component_a_menu, {
            key: 0,
            "inline-collapsed": info.menu.toggle,
            "selected-keys": info.menu.selected,
            "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((info.menu.selected) = $event)),
            onSelect: onSelect
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.menu.modules, (m, k) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, { key: k }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(IconFont), {
                      type: `icon-${m.icon}`
                    }, null, 8, ["type"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(m.title), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["inline-collapsed", "selected-keys"]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_divider),
      (_unref(editor).activity)
        ? (_openBlock(), _createBlock(_component_a_space, {
            key: 1,
            direction: "vertical",
            align: "center",
            style: {"width":"100%"},
            size: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_typography_text, { type: "secondary" }, {
                default: _withCtx(() => [
                  _createTextVNode("标签")
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editor).activity.tags(), (t) => {
                return (_openBlock(), _createBlock(_component_a_tag, { key: t }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(cardTags)[t]), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["toggle"]))
}
}

})